<template>
  <div>
    <div class="comment__footer">
      <div class="comment__user">
        <img :src="fetchImage(account.avatar)" :alt="account.full_name" :title="account.full_name" />
      </div>
      <div class="comment__input">
        <comment-input v-model="formData.content" @submit="handleSubmit" />
        <!-- <editor-content class="editor" data-placeholder="コメントを入力する" :editor="editor" @keydown.native="keydownHandler" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { fetchImageMixin } from '~/mixins/global'
import { generateHTML } from '@tiptap/html'
import { Editor, VueRenderer } from '@tiptap/vue-2'
import Text from '@tiptap/extension-text'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Placeholder from '@tiptap/extension-placeholder'
import HardBreak from '@tiptap/extension-hard-break'
import tippy from 'tippy.js'
import Mention from '@tiptap/extension-mention'
import BasicMentionList from '@/components/particles/extensions/BasicMentionList'
import CommentInput from '@/components/particles/CommentInput'
import cheerio from 'cheerio'

export default {
  name: 'f-comment-footer',
  props: {
    proposalEncryptId: {
      type: String,
      default: null
    },
    isProposal: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    CommentInput,
  },
  mixins: [fetchImageMixin],
  data: () => ({
    submitting: false,
    formData: {
      content: '',
      id: null,
      from: 1,
      currentStatus: null,
    },
    editor: null,
  }),
  mounted() {
    this.editor = new Editor({
      content: this.computedValue,
      extensions: [
        Document,
        Paragraph,
        Text,
        Placeholder,
        HardBreak,
        Mention.configure({
          HTMLAttributes: {
            class: 'mention',
          },
          suggestion: {
            items: (query) => {
              const users = this.users
                .map((user) => ({
                  value: user.id,
                  label: user.full_name,
                }))
                .filter((user) => {
                  return user.label.toLowerCase().includes(query.trim().toLowerCase())
                })

              return users
            },
            command: ({ editor, range, props }) => {
              editor
                .chain()
                .focus()
                .insertContentAt(range, [
                  {
                    type: 'mention',
                    attrs: {
                      id: props.value,
                      label: props.label,
                    },
                  },
                ])
                .run()
            },
            render: () => {
              let component
              let popup

              return {
                onStart: (props) => {
                  component = new VueRenderer(BasicMentionList, {
                    parent: this,
                    propsData: props,
                  })

                  popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                  })

                  if (popup.length) {
                    popup[0].popper.classList.add('mention-popup')
                  }
                },
                onUpdate(props) {
                  component.updateProps(props)

                  popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                  })
                },
                onKeyDown(props) {
                  if (props.event.key === 'Escape') {
                    popup[0].hide()

                    return true
                  }

                  return component.ref?.onKeyDown(props)
                },
                onExit() {
                  popup[0].destroy()
                  component.destroy()
                },
              }
            },
          },
        }),
      ],
      onUpdate: () => {
        this.formData.content = this.editor.getJSON()
      },
    })
  },
  methods: {
    ...mapActions({
      storeComment: 'frontend/proposals/storeComment',
    }),
    async handleSubmit(event) {
      let formData = {}

      const convertHTML = generateHTML(this.formData.content, [
        Document,
        Paragraph,
        Text,
        HardBreak,
        Mention.configure({
          HTMLAttributes: {
            class: 'mention',
          },
        }),
      ])

      const $ = cheerio.load(convertHTML)
      if (!$.text().trim()) {
        return
      }

      this.submitting = true
      let isProposal = 0;
      if(this.$props.isProposal) {
        isProposal = 1;
      }

      formData.proposal_id = this.$route.params.id || this.proposalEncryptId
      formData.content = convertHTML;
      formData.is_proposal = isProposal;
      formData.mention_ids = this.formData.content.content.reduce((acc, cur) => {
        if(cur.hasOwnProperty('content')) {
          cur.content.forEach(item => {
            item.type === 'mention' && acc.push(item.attrs.id);
          })
        }

        return acc;
      }, []).toString();

      await this.storeComment(formData)
      await this.$parent.scrollToEnd()
      this.formData.content = null
      this.submitting = false
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.frontend.auth.user,
      users: (state) => state.frontend.user.users,
      proposalId: (state) => state.frontend.proposals.proposalId,
      proposalFrom: (state) => state.frontend.proposals.proposalFrom,
      currentStatus: (state) => state.frontend.proposals.currentStatus,
    }),
  },
}
</script>

<style>
.ProseMirror {
  padding: 12px;
}

.ProseMirror p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: #ced4da;
  pointer-events: none;
  height: 0;
}

.ProseMirror:focus-visible {
  outline: #166af0 solid 1px;
}

</style>
